import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const SeatRequiredAlert = () => {
  return /*#__PURE__*/_jsx(Alert, {
    marginBlock: "400",
    type: "warning",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "knowledgeContentUI.seatRequiredAlert.body_jsx",
      elements: {
        Link: ({
          children
        }) => /*#__PURE__*/_jsx(Link, {
          external: true,
          href: 'https://www.hubspot.com/pricing/service',
          children: children
        })
      }
    })
  });
};
export default SeatRequiredAlert;